import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { JourneyComponent } from './pages/journey/journey.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { SolutionHomeComponent } from './pages/solutions/solution-home/solution-home.component';
import { SolutionHotelComponent } from './pages/solutions/solution-hotel/solution-hotel.component';
import { SolutionWorkspaceComponent } from './pages/solutions/solution-workspace/solution-workspace.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { TermsOfUseComponent } from './pages/terms-of-use/terms-of-use.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { OrdersListComponent } from './pages/orders-list/orders-list.component';
import { OrderDetailsComponent } from './pages/order-details/order-details.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { LegacyFileComponent } from './pages/legacy-file/legacy-file.component';
import { EquipmentComponent } from './pages/equipment/equipment.component';
import { EquipmentDetailComponent } from './pages/equipment-detail/equipment-detail.component';
import { GatewaysComponent } from './pages/gateways/gateways.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { AdminEquipmentComponent } from './pages/admin-equipment/admin-equipment.component';
import { UsersComponent } from './pages/users/users.component';
import { FilesComponent } from './pages/files/files.component';
import { AccountComponent } from './pages/account/account.component';
import { MyFilesComponent } from './pages/my-files/my-files.component';
import { ActivateAccountComponent } from './pages/activate-account/activate-account.component';
import { adminGuard } from './core/guards/admin.guard';
import { localAccountGuard } from './core/guards/local-account.guard';
import { cloudAccountGuard } from './core/guards/cloud-account.guard';
import { dashboardGuard } from './core/guards/dashboard.guard';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent

    },
    {
        path: 'journey',
        component: JourneyComponent

    },
    {
        path: 'contact',
        component: ContactComponent

    },
    {
        path: 'projects/:slug',
        component: ProjectsComponent
    },
    {
        path: 'solution',
        redirectTo: 'solution/home',
        pathMatch: 'full'
    },
    {
        path: 'solution/home',
        component: SolutionHomeComponent
    },
    {
        path: 'solution/hotel',
        component: SolutionHotelComponent
    },
    {
        path: 'solution/workspace',
        component: SolutionWorkspaceComponent
    },

    {
        path: 'about-us',
        component: AboutUsComponent
    },
    {
        // Same URL shape as the old site, so links already shared keep working.
        path: 'equipment',
        component: EquipmentComponent
    },
    {
        path: 'equipment/:slug',
        component: EquipmentDetailComponent
    },
    {
        path: 'terms-of-use',
        component: TermsOfUseComponent
    },
    {
        // Gateway customers and admins only: a local account has Files instead.
        path: 'gateways',
        component: GatewaysComponent,
        canActivate: [cloudAccountGuard],
    },
    {
        path: 'categories',
        component: CategoriesComponent,
        canActivate: [adminGuard],
    },
    {
        path: 'users',
        component: UsersComponent,
        canActivate: [adminGuard],
    },
    {
        path: 'files',
        component: FilesComponent,
        canActivate: [adminGuard],
    },
    {
        // Admin CRUD over the public /equipment catalogue. Its own path because
        // 'equipment' is the public catalogue page.
        path: 'equipment-management',
        component: AdminEquipmentComponent,
        canActivate: [adminGuard],
    },
    {
        path: 'account',
        component: AccountComponent,
    },
    {
        // File portal: local accounts only (cloud gateway customers never had it)
        path: 'my-files',
        component: MyFilesComponent,
        canActivate: [localAccountGuard],
    },
    {
        // Matches the activation link in the cloud's email:
        //   /activate_account.php?code=...
        path: 'activate_account.php',
        component: ActivateAccountComponent,
    },
    // Admin-only dashboard. The backend enforces the same rule on every
    // dashboard endpoint (fyesAdminRequired).
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [dashboardGuard],
    },
    {
        path: 'dashboard/orders',
        component: OrdersListComponent,
        canActivate: [dashboardGuard],
    },
    {
        path: 'dashboard/orders/:id',
        component: OrderDetailsComponent,
        canActivate: [dashboardGuard],
    },
    {
        // Admin-only, unlike the rest of the dashboard: canAccessOrders covers
        // the overview and orders, not the contact inbox.
        path: 'dashboard/messages',
        component: MessagesComponent,
        canActivate: [adminGuard],
    },
    {
        // Where the backend's legacy redirect sends people when no file claims
        // the path (see worthy-services rest/fyes/legacy/redirect.ts).
        path: 'file-unavailable',
        component: LegacyFileComponent
    },
    {
        // Fallback for environments where the root redirect is not wired up
        // yet: static hosts that do serve index.html for these paths will let
        // the SPA resolve them. Must sit above the ** fallback.
        path: 'wp-content/uploads/**',
        component: LegacyFileComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
];
